module.exports = __webpack_public_path__ + "img/vitali.c__600x600.f7951f17.jpg";